import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[disablePaste]'
})
export class DisablePasteDirective {

  @HostListener('paste', ['$event'])
  onPaste(event: any) {
    event.preventDefault();
    event.stopPropagation();
  }
}
